import { NgModule } from "@angular/core";
import { StoreModule } from "@ngrx/store";
import { EffectsModule } from "@ngrx/effects";
import { SubscriptionEffects } from "./subscription.effects";
import { subscriptionReducer } from "./subscription.reducer";

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature("subscription", subscriptionReducer),
        EffectsModule.forFeature([SubscriptionEffects]),
    ],
    providers: []
})
export class SubscriptionStateModule { }
